var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFastDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    rx: 61.5,
    fill: "#38419A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 75.75C63.3714 75.75 65.2244 75.3815 66.9533 74.6653C68.6822 73.9492 70.2531 72.8995 71.5763 71.5763C72.8995 70.2531 73.9492 68.6822 74.6653 66.9533C75.3815 65.2244 75.75 63.3714 75.75 61.5C75.75 59.6287 75.3815 57.7757 74.6653 56.0468C73.9492 54.3179 72.8995 52.747 71.5763 51.4238C70.2531 50.1005 68.6822 49.0509 66.9533 48.3348C65.2244 47.6186 63.3714 47.25 61.5 47.25C57.7207 47.25 54.0962 48.7514 51.4238 51.4238C48.7514 54.0962 47.25 57.7207 47.25 61.5C47.25 65.2794 48.7514 68.9039 51.4238 71.5763C54.0962 74.2487 57.7207 75.75 61.5 75.75ZM78.9167 61.5C78.9167 71.1188 71.1188 78.9167 61.5 78.9167C51.8813 78.9167 44.0834 71.1188 44.0834 61.5C44.0834 51.8813 51.8813 44.0834 61.5 44.0834C71.1188 44.0834 78.9167 51.8813 78.9167 61.5ZM66.25 68.4889L59.9167 62.1555V51.2084H63.0834V60.8445L68.4889 66.25L66.25 68.4889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDelivery);
export default __webpack_public_path__ + "static/media/fastDelivery.8d651dd5394fa7bdcc7c07d0e01376cf.svg";
export { ForwardRef as ReactComponent };